<template>
  <vx-card :title="id === null ? 'Cadastrar Estabelecimento' : 'Editar Estabelecimento'">
    <vs-tabs :color="colorx" v-model="tabIndex">
      <vs-tab label="Dados Básicos">
        <LegalEntityForm :services="services"
                         :legalEntityId="id"
                         :legalEntity="legalEntity"
                         @update-data="handleUpdateDataLegalEntity"></LegalEntityForm>
      </vs-tab>
      <vs-tab label="Responsável" :disabled="isTabEnabled">
        <Responsable :services="services" :legalEntityId="legalEntity.id" v-if="legalEntity.people_id"/>
      </vs-tab>
      <vs-tab label="Endereço" :disabled="isTabEnabled">
        <Address :services="services" :people_id="legalEntity.people_id" v-if="legalEntity.people_id"/>
      </vs-tab>
      <vs-tab label="Telefone" :disabled="isTabEnabled">
        <Phone :services="services" :people_id="legalEntity.people_id" v-if="legalEntity.people_id"/>
      </vs-tab>
      <vs-tab label="Email" :disabled="isTabEnabled">
        <Email :services="services" :people_id="legalEntity.people_id" v-if="legalEntity.people_id"/>
      </vs-tab>
      <vs-tab label="Dados Bancários" :disabled="isTabEnabled">
        <Bank :services="services"
              :serviceDelegate="services.legalEntityService"
              :entityId="id"
              :people_id="legalEntity.people_id"
              v-if="legalEntity.people_id"/>
      </vs-tab>
      <vs-tab label="Professores" :disabled="isTabEnabled">
        <Teacher :services="services" :people_id="legalEntity.people_id" :legalEntityId="legalEntity.id" v-if="legalEntity.people_id"/>
      </vs-tab>
      <vs-tab label="Modalidades" :disabled="isTabEnabled">
        <Modality :services="services"
                  :serviceDelegate="services.legalEntityService"
                  :people_id="legalEntity.people_id"
                  :entityId="id"
                  v-if="legalEntity.people_id"/>
      </vs-tab>
      <vs-tab label="Repasse (Stripe)" :disabled="isTabEnabled">
        <StripeConnect :legalEntityId="legalEntity.id" v-if="legalEntity.id"/>
      </vs-tab>
      <vs-tab v-if="canSeeBillingPlan" label="Plano de Cobrança" :disabled="isTabEnabled">
        <BillingPlan :legalEntityId="legalEntity.id" v-if="legalEntity.id"/>
      </vs-tab>
      <vs-tab label="Imagens" :disabled="isTabEnabled">
        <Images :serviceDelegate="services.legalEntityService"
                :people_id="legalEntity.people_id"
                :entityId="legalEntity.id"
                :imagesList="legalEntity.images"
                target="legal_entities"
                hint="Tamanho recomendado: 1200×675px (paisagem, 16:9), mesma proporção da capa."
                v-if="legalEntity.people_id"/>
      </vs-tab>
      <!-- <vs-tab label="Documentos" :disabled="isTabEnabled">
        <Document :services="services" personType="PJ" />
      </vs-tab> -->
    </vs-tabs>
  </vx-card>
</template>

<script>
import Datepicker from 'educatena-vuejs-datepicker'
import { ptBR } from 'educatena-vuejs-datepicker/dist/locale'
import vSelect from 'vue-select'
import Constants from '../../../../util/Constants'

import FederationUnitService from '@/services/api/FederationUnitService'
import CityService from '@/services/api/CityService'
import LegalEntityService from '@/services/api/LegalEntityService'
import EmailTypeService from '@/services/api/EmailTypeService'
import AddressService from '@/services/api/AddressService'
import AddressTypeService from '@/services/api/AddressTypeService'
import EmailService from '@/services/api/EmailService'
import FinancialInstitutionService from '@/services/api/FinancialInstitutionService'
import BankDetailService from '@/services/api/BankDetailService'
import PhoneTypeService from '@/services/api/PhoneTypeService'
import PhoneService from '@/services/api/PhoneService'
import AreaCodeService from '@/services/api/AreaCodeService'
import ModalityService from '@/services/api/ModalityService'
import DocumentTypeService from '@/services/api/DocumentTypeService'
import DocumentPeopleService from '@/services/api/DocumentPeopleService'

import LegalEntityForm from '../tabs/LegalEntityForm'
import Address from '../tabs/Address'
import Email from '../tabs/Email'
import Bank from '../tabs/Bank'
import Phone from '../tabs/Phone'
//import Document from '../tabs/Document'
import Teacher from '../tabs/Teacher'
import Modality from '../tabs/Modality'
import Responsable from '../tabs/Responsable'
import Images from '../tabs/Images'
import StripeConnect from '../tabs/StripeConnect'
import BillingPlan from '../tabs/BillingPlan'

export default {
  components: {
    Datepicker,
    vSelect,
    Address,
    Email,
    Bank,
    Phone,
    Document,
    Teacher,
    Modality,
    Responsable,
    Images,
    StripeConnect,
    BillingPlan,
    LegalEntityForm,
    Constants,
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    tabIndex: 0,
    legalEntity: {
      id: null,
      people_id: null,
      cnpj: null,
      trading_name: null,
      company_name: null,
      main_office_id: null,
      mainOffice: null,
      status: null,
      description: null,
      logo_url: null,
      images: [],
    },
    services: {
      federationUnitService: null,
      cityService: null,
      peopleService: null,
      legalEntityService: null,
      naturalEntityService: null,
      emailTypeService: null,
      addressService: null,
      addressTypeService: null,
      emailService: null,
      financialInstitutionService: null,
      bankDetailService: null,
      phoneTypeService: null,
      phoneService: null,
      areaCodeService: null,
      documentTypeService: null,
      documentPeopleService: null,
      modalityService: null,
    },
  }),
  methods: {
    loadData(){
      this.$vs.loading()
      this.services.legalEntityService.read(this.id).then(
        data => {

          this.legalEntity.id = data.id
          this.legalEntity.people_id = data.people_id
          this.legalEntity.cnpj = data.cnpj
          this.legalEntity.trading_name = data.trading_name
          this.legalEntity.company_name = data.company_name
          this.legalEntity.main_office_id = data.main_office_id
          this.legalEntity.status = data.status
          this.legalEntity.description = data.description
          this.legalEntity.logo_url = data.logo_url
          this.legalEntity.images = data.images

          this.$vs.loading.close()
        },
        error => {this.$vs.loading.close()}
      )
    },
    handleUpdateDataLegalEntity(data){
      if(!this.id){ //Include
        this.$router.push(`/legal_entities/${data.id}/edit`)
        this.legalEntity = data
        /*
        this.$router.push({
          path: `/legal_entities/${data.id}/edit`,
          query: { refresh: new Date().getTime() }, // Parâmetro único
        })
          */
      }
    },
  },
  computed: {
    isTabEnabled() {
      return this.id === null
    },
    // v-if (e não v-permission) porque a diretiva remove o nó no inserted e
    // confunde a contagem de abas do vs-tabs.
    canSeeBillingPlan() {
      return this.$acl.hasPermission('fee_plans.show')
    }
  },
  mounted() {
    if(this.id){
      this.loadData()
    }
  },
  beforeMount() {
    this.services.federationUnitService = FederationUnitService.build(this.$vs)
    this.services.cityService = CityService.build(this.$vs)
    this.services.legalEntityService = LegalEntityService.build(this.$vs)
    this.services.emailTypeService = EmailTypeService.build(this.$vs)
    this.services.addressService = AddressService.build(this.$vs)
    this.services.addressTypeService = AddressTypeService.build(this.$vs)
    this.services.emailService = EmailService.build(this.$vs)
    this.services.financialInstitutionService = FinancialInstitutionService.build(this.$vs)
    this.services.bankDetailService = BankDetailService.build(this.$vs)
    this.services.phoneTypeService = PhoneTypeService.build(this.$vs)
    this.services.phoneService = PhoneService.build(this.$vs)
    this.services.areaCodeService = AreaCodeService.build(this.$vs)
    this.services.documentTypeService = DocumentTypeService.build(this.$vs)
    this.services.documentPeopleService = DocumentPeopleService.build(this.$vs)
    this.services.modalityService = ModalityService.build(this.$vs)
  }
}
</script>
